function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { decl } from '@yandex-lego/i-bem-react';
import _icon from "./../../icon/icon.react.js";

var Icon = _icon.applyDecls();

import "./../../icon/icon.css";
import _logo from "./../../logo/logo.react.js";

var Logo = _logo.applyDecls();

import "./../../logo/logo.css";
export default decl({
  block: 'header2',
  elem: 'logo',
  mods: function mods(_ref) {
    var size = _ref.size,
        preset = _ref.preset;
    return {
      size: size,
      preset: preset
    };
  },
  content: function content(_ref2) {
    var name = _ref2.name,
        url = _ref2.url,
        service = _ref2.service,
        children = _ref2.children;
    var type = url ? 'link' : undefined;

    if (children) {
      return children;
    }

    return [React.createElement(Logo, _extends({
      key: "main"
    }, {
      url: url,
      name: name,
      type: type
    })), service && React.createElement(Icon, _extends({
      key: "service"
    }, {
      mix: [{
        block: 'header2',
        elem: 'logo'
      }, {
        block: 'logo',
        mods: {
          service: 'yes'
        }
      }]
    }))];
  }
});